
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UI2UpdateSeatsModal',
  props: {
    seatsCount: {
      type: Number,
      required: true
    },
    seatsUsed: {
      type: Number,
      required: true
    },
    seatsMax: {
      type: Number,
      required: true
    },
    seatsMin: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isValid(): boolean {
      return (
        Number(this.seatsCountValue) <= this.seatsMax &&
        Number(this.seatsCountValue) >= this.seatsMin
      )
    },
    seatsCountValue: {
      get(): number {
        return this.seatsCount
      },
      set(value: number) {
        this.$emit('update:seatsCount', value)
      }
    }
  }
})
